/**
 * Helpers purs de la playlist d'une vidéo YouTube Studio (table
 * `youtube_video_items`). Mapping ordre → lignes positionnées, réutilisé par la
 * mutation d'upsert (apps/app) et testable sans dépendance Supabase.
 */

import type { VideoPlaylistItem } from '../schemas/youtube';

/** Ligne d'insertion dans `youtube_video_items` (position dérivée de l'ordre). */
export interface YoutubeVideoItemRow {
  video_id: string;
  exercise_id: string;
  attempt_id: string | null;
  position: number;
}

/**
 * Transforme une playlist ordonnée en lignes `youtube_video_items` pour un
 * `videoId` donné : `position` = index dans la liste (0 = item primaire).
 */
export function playlistItemRows(
  videoId: string,
  items: VideoPlaylistItem[],
): YoutubeVideoItemRow[] {
  return items.map((item, position) => ({
    video_id: videoId,
    exercise_id: item.exercise_id,
    attempt_id: item.attempt_id ?? null,
    position,
  }));
}
